// extracted by mini-css-extract-plugin
module.exports = {"TooltipText":"_1A-QXI"};